import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { ReactNode } from 'react';
import { useIsSmallScreen } from '@/components/ui/breakpoint';

type Props = {
  trigger: ReactNode; // The trigger element (e.g., button or text)
  title?: string; // Optional title for the dialog
  children: ReactNode; // Content inside the popover/dialog
  open: boolean; // Controlled open state
  setOpen: (value: boolean) => void; // Function to update the open state
  dialogClassName?: string; // Optional custom className for content
  popoverClassName?: string; // Optional custom className for content
};

export function PopoverOrDialog({ trigger, title, children, open, setOpen, dialogClassName, popoverClassName }: Props) {
  const isSmallScreen = useIsSmallScreen();

  return isSmallScreen ? (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className={dialogClassName}>
        {title && (
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
        )}
        {children}
      </DialogContent>
    </Dialog>
  ) : (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent className={popoverClassName}>{children}</PopoverContent>
    </Popover>
  );
}
